// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"Buttons_PrimaryButton__bhrcT","SecondaryButton":"Buttons_SecondaryButton__RjII-","PrimaryButton_disabled":"Buttons_PrimaryButton_disabled__Lpjgs"};